import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { SegmentedOptions } from 'ui';
import type { EventsType } from '../DeclinedEventsModal';

export const useGetTabOptions = (): SegmentedOptions<EventsType> => {
  const { t } = useTranslation();

  return useMemo(
    (): SegmentedOptions<EventsType> => [
      {
        label: t('Upcoming'),
        value: 'upcoming',
      },
      {
        label: t('Past'),
        value: 'past',
      },
    ],
    [t],
  );
};
